<script>
import { mapGetters, mapActions } from "vuex";
import adminOlimpiada2024sList from "../../components/AdminOlimpiada2024sList.vue";

export default {
  components: { adminOlimpiada2024sList },

  data: (vm) => ({
    tab: Number(vm.$route.query.tab) || 0,
    isLoading: false,
  }),

  created() {
    this.INIT_COUNT();
  },

  computed: {
    ...mapGetters("admin-olimpiada2024s", ["GET_COUNT"]),
    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  methods: {
    ...mapActions("admin-olimpiada2024s", ["INIT_COUNT"]),

    onTap(tab) {
      window.open(`?tab=${tab}`, "_blank");
    },
  },
};
</script>

<template>
  <div>
    <v-container v-if="isSupperAdmin" fluid>
      <div class="_cards-wrap">
        <div>
          <v-card class="mx-auto" dark color="#288FDA" elevation="0">
            <v-card-text>
              <div class="card-title" v-text="$t('All olimpiada')" />
              <div class="card-count">{{ GET_COUNT.ALL | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <!--        <div>
          <v-card class="mx-auto" dark color="orange" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Submitted card") }}</div>
              <div class="card-count">{{ GET_COUNT.SUBMITTED | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#e62d2d" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Rejected card") }}</div>
              <div class="card-count">{{ GET_COUNT.REJECTED | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#8E44AD" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Accepted card") }}</div>
              <div class="card-count">{{ GET_COUNT.ACCEPTED | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#F5B7B1" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("EXAMINED") }}</div>
              <div class="card-count">{{ GET_COUNT.EXAMINED | sum }}</div>
            </v-card-text>
          </v-card>
        </div>
        <div>
          <v-card class="mx-auto" dark color="#26d316" elevation="0">
            <v-card-text>
              <div class="card-title">{{ $t("Passed card") }}</div>
              <div class="card-count">{{ GET_COUNT.PASSED | sum }}</div>
            </v-card-text>
          </v-card>
        </div>-->
      </div>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-card class="position-relative" outlined>
            <v-tabs v-model="tab" color="accent">
              <v-tab
                @click.ctrl="onTap(0)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('barcha ariza')"
              />
              <!--              <v-tab
                @click.ctrl="onTap(1)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('yangi ariza')"
              />
              <v-tab
                @click.ctrl="onTap(2)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('qaytarilgan ariza')"
              />
              <v-tab
                @click.ctrl="onTap(3)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('qabul qilingan ariza')"
              />
              <v-tab
                @click.ctrl="onTap(4)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('EXAMINED')"
              />

              <v-tab
                @click.ctrl="onTap(5)"
                :disabled="isLoading"
                class="transform-none"
                v-text="$t('oqishga kirgan ariza')"
              />-->
            </v-tabs>

            <adminOlimpiada2024sList
              @loading="(v) => (isLoading = v)"
              v-model="tab"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.card-title {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.527);

  margin-bottom: 20px;
  padding-bottom: 10px;

  font-weight: 500;
  font-size: 18px;

  text-transform: uppercase;

  text-align: center;
}

.card-count {
  font-size: 24px;
  font-weight: 500;

  color: white;

  text-align: center;
}

.card-table {
  width: 100%;
  box-shadow: 0px 2px 4px rgba(128, 128, 128, 0.267);
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.right-form {
  padding: 15px 15px 10px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.right-form div {
  width: 300px;
  height: 60px;
}

._cards-wrap {
  @media only screen and (max-width: 1200px) {
    > div {
      margin: 20px 0;
    }
  }

  @media only screen and (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
